import React, { useEffect, useState } from 'react'
import PaymentSuccessComponent from '../../Components/PaymentSuccessComponent/PaymentSuccessComponent'
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';


const PaymentSuccess = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>


        <Header />
        <PaymentSuccessComponent />
        <Footer />
      </div>
    </>
  )
}

export default PaymentSuccess
